/** @jsxImportSource @emotion/react */

import Button from "../../components/Button";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../../connections";
import { useContext, useState } from "react";
import { useLogout } from "../../hooks/services/uselogout";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import AppBar from "../../components/AppBar";
import { useGetNavItems } from "../Home/appbarNav";
import Dialog from "@mui/material/Dialog";
import { UserContext } from "../../context/UserContext";
import Snackbar from "../../components/Snackbar";
import uuid from "react-uuid";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import axios from "axios";
import useStyles from "./index.styles";

const Accountdelete = () => {
  const { userDetails } = useContext(UserContext);
  const [success, setsuccess] = useState(false);
  const [errortoast, seterrortoast] = useState(false);
  const [open, setOpen] = React.useState(false);
  const { setPayloadsLogout } = useLogout();
  const navigate = useNavigate();
  const styles = useStyles();

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handlelogout = () => {
    setPayloadsLogout({
      user_uuid: userDetails?.user_uuid,
    });
    setTimeout(() => {
      navigate("/login");
    }, 1000);
  };

  const HandleDelete = () => {
    axios
      .delete(`${baseUrl}/user/delete/account/${userDetails?.user_uuid}`, {
        headers: {
          "x-auth-token": userDetails?.token,
        },
      })
      .then(() => {
        setTimeout(() => {
          handleClose();
          handlelogout();
        }, 1000);
        setsuccess(true);
      })
      .catch(() => {
        seterrortoast(true);
      });
  };

  const RedirectFunction = () => {
    navigate("/home");
  };

  return (
    <>
      {/* ── Confirmation Dialog ──────────────────────────── */}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{ css: styles.dialogPaper }}
      >
        <DialogTitle id="alert-dialog-title" css={styles.dialogTitle}>
          Confirm Account Deletion
        </DialogTitle>
        <DialogContent css={styles.dialogContent}>
          <DialogContentText id="alert-dialog-description">
            This will permanently remove your account, reward points, and all
            associated data. You cannot undo this action.
          </DialogContentText>
        </DialogContent>
        <DialogActions css={styles.dialogActions}>
          <Button onClick={handleClose} css={styles.dialogCancelBtn}>
            Cancel
          </Button>
          <Button onClick={HandleDelete} css={styles.dialogConfirmBtn}>
            <DeleteOutlinedIcon sx={{ fontSize: 18, mr: 0.5 }} />
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Page ─────────────────────────────────────────── */}
      <AppBar navItems={useGetNavItems({}).navItems} />

      <div css={styles.pageWrapper}>
        <div css={styles.card}>
          <div css={styles.iconWrapper}>
            <WarningAmberRoundedIcon />
          </div>

          <h2 css={styles.heading}>Delete Your Account?</h2>

          <p css={styles.description}>
            By selecting <span css={styles.warningHighlight}>"Delete"</span>,
            your account and all associated reward points will be{" "}
            <span css={styles.warningHighlight}>permanently deleted</span>. This
            action cannot be undone.
          </p>

          <div css={styles.buttonGroup}>
            <Button
              variant="contained"
              color="secondary"
              css={styles.backButton}
              onClick={RedirectFunction}
            >
              <ArrowBackIcon sx={{ fontSize: 18, mr: 0.5 }} />
              Go Back
            </Button>

            <Button
              variant="contained"
              color="secondary"
              css={styles.deleteButton}
              onClick={handleClickOpen}
            >
              <DeleteOutlinedIcon sx={{ fontSize: 18, mr: 0.5 }} />
              Delete Account
            </Button>
          </div>
        </div>
      </div>

      {errortoast && (
        <Snackbar
          key={uuid()}
          message="Something went wrong!"
          isOpen={errortoast}
        />
      )}
      {success && (
        <Snackbar
          key={uuid()}
          message="Account deleted successfully!"
          isOpen={success}
          severity="success"
        />
      )}
    </>
  );
};

export default Accountdelete;
